import { useLocalePath, useT } from "../../i18n";
import { SITE_IMAGERY } from "../../config/siteImagery";
import { ResponsiveImage } from "../ResponsiveImage";
import { Reveal } from "../Reveal";
import { TextLink } from "../TextLink";

export const CompanyIntro = ({ index = "06" }) => {
  const t = useT();
  const lp = useLocalePath();
  return (
    <section data-testid="company-section" className="bg-paper py-24 text-ink sm:py-32 lg:py-40">
      <div className="container-x grid gap-14 lg:grid-cols-12 lg:items-center lg:gap-10">
        <Reveal className="lg:col-span-6 xl:col-span-7">
          <div className="relative aspect-[4/3] overflow-hidden bg-mist lg:aspect-[5/4]">
            <ResponsiveImage image={SITE_IMAGERY.company} sizes="(min-width: 1024px) 55vw, 100vw" className="zoom-on-view absolute inset-0 h-full w-full object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.12} className="lg:col-span-6 lg:pl-10 xl:col-span-5 xl:pl-16">
          <p className="eyebrow flex items-center gap-4 opacity-55">
            <span className="tabular-nums">{index}</span>
            <span className="h-px w-8 bg-current" aria-hidden />
            {t("company.eyebrow")}
          </p>
          <h2 className="h-section font-display mt-5" data-testid="company-title">{t("company.title")}</h2>
          <p className="mt-6 max-w-md text-ink/65">{t("company.body")}</p>
          <TextLink to={lp("company")} testId="company-cta" className="mt-10">{t("company.cta")}</TextLink>
        </Reveal>
      </div>
    </section>
  );
};
